import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import ArticleListing from "../../Components/Articles/ArticleListing";
import { KBContext } from "../../Context/index";
import { useCategoryBySlug } from "../../hooks/apis/useCategory";
import { useCategoryArticles } from "../../hooks/apis/useCategoryArticles";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import { handleGainSightEventForPageNotFound } from "../../gainSightIntegration";

export default function ArticleList() {

  const { data } = useContext(KBContext);
  const navigate = useNavigateWithSearch();

  const { categorySlug } = useParams();
  const { data: selectedCategory, error } = useCategoryBySlug({ categorySlug });
  const { data: articleData, isLoading } = useCategoryArticles({ categorySlug });

  const handleArticleClick = (article) => {
    navigate(`/${selectedCategory.slug}/${article.slug}`);
  };

  useEffect(() => {
    if( !error ){
      return;
    }
    if( error?.response?.status === 404 ){
      handleGainSightEventForPageNotFound(window.location.href);
    }
    navigate("/not-found");
  }, [ error ]);

  return (
    <ArticleListing
      kbdata={data}
      selectedCategory={selectedCategory}
      articles={articleData ?? []}
      isLoading={isLoading}
      handleArticleClick={handleArticleClick}
    />
  );
}
